import StoreDetails from "./StoreDetails";

export default StoreDetails;